import { firestore, firebaseStorage } from '../plugins/firebase'
import { localStorageService } from './LocalStorageService'
import slugify from 'slugify'

const user = localStorageService.getItem('authenticatedUser')
let accountId
let createdBy

if (user) {
  accountId = user.accountId
  createdBy = user.id
}

const crudService = (collection, data) => {
  const createInformation = (obj) => {
    return {
      ...obj,
      createdBy,
      accountId,
      createdAt: (+new Date())
    }
  }

  const getList = async () => {
    const response = await firestore.collection(collection)
      // .where('accountId', '==', accountId)
      .get()

    return response
  }

  const handleFileFields = async (data) => {
    const keys = Object.keys(data)
    const files = keys.filter(item => item.startsWith('file') && data[item].includes('base64'))

    if (files.length) {
      const uploads = files.map(async (item) => {
        const fileUrl = await uploadFile(data[item], item)
        data[item] = fileUrl
        return fileUrl
      })
      await Promise.all(uploads)
    }

    return data
  }

  const createItem = async () => {
    // Upload related
    data = await handleFileFields(data)

    // Adding accountId and createdBy
    data = createInformation(data)

    const response = await firestore
      .collection(collection)
      .add(data)

    if (response) {
      const savedDocument = await response.get()
      const savedData = await savedDocument.data()

      let newObj = {
        id: response.id,
        ...savedData
      }
      return newObj
    }

    return false
  }

  const getItemById = async () => {
    const itemId = data

    const item = await firestore
      .collection(collection)
      .doc(itemId)
      .get()

    return item.data()
  }

  const deleteItem = async () => {
    const itemId = data.id
    await firestore
      .collection(collection)
      .doc(itemId).delete()
    return true
  }

  const updateItem = async () => {
    const itemId = data.id
    // Upload related
    data = await handleFileFields(data)

    await firestore
      .collection(collection)
      .doc(itemId)
      .set(data, { merge: true })
  }

  const uploadFile = async (file, field) => {
    if (!file) return

    const dir = `/Maestro/${accountId}/${collection}/`
    const ref = firebaseStorage.ref().child(dir)

    file = file.split(',')[1]

    let entityName = data.name || data.title || collection
    entityName = slugify(entityName, { lower: true })

    const fileName = `${(+new Date())}-${entityName}-${field}.jpg`
    const task = ref.child(fileName).putString(file, 'base64')
    const response = await task

    const url = response.ref.getDownloadURL()

    return url
  }

  return {
    getList,
    createItem,
    getItemById,
    updateItem,
    deleteItem
  }
}

export default crudService
